export const tableFilterParser = (filters: { id: string | number; value: any }[]) => {
  return filters.reduce((acc: any, { id, value }: any) => {
    return { ...acc, [id]: value };
  }, {});
};
